import React from "react";
import UploadFile from "../../FormFields/UploadFile";

const MessageA21 = (props) => {
  props?.setEnableAttachment(true)
  return <UploadFile ref={props.uploadRef}   {...props} />;
};

export default MessageA21;
